module.exports = __webpack_public_path__ + "img/img_assistant_phone_img2.b5f10e7d.png";